<template lang="pug">
v-row.entity-controller.pa-5(:class="{ ['flex-column']: vertical }")
  v-col.entity-controller_header.py-0(cols="4")
    v-row
      v-col.d-flex.align-center
        h2.primary--text {{ $t('GroupParty.title') }}
    app-simple-entity-search(:error-messages="searchErrors", :loads="searchLoads" :entity="partyEntity", v-bind="{ disabled }", @input="setInstance")
  v-col.entity-controller_display.py-0(cols="8")
    v-row(wrap)
      v-col(v-for="(p, index) in parties", cols="4", :key="index")
        .entity-display.px-5(:class="{'background': true}")
          v-row
            .display__close
              g-btn.text--text(
                  icon,
                  small,
                  @click="removeParty(p)",
                )
                  v-icon mdi-close
            v-col.pt-0.entity-display_form
              .d-flex.pa-1
                b.px-1.ellipsis {{ p.name }}
              .d-flex.pa-1
                .px-1.ellipsis {{ p.externalId }}
</template>

<style lang="scss" scoped>
.entity-controller {
  .entity-display {
    position: relative;
  }
  .display__close {
    position: absolute;
    top: 0;
    right: 0;
  }
}
.entity-display.background.px-5 {
  border: 0.8px solid #3200E6 !important;
  border-radius: 5px;
}
.ellipsis {
  white-space: nowrap;
  width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>

<script>
import EntityMixin from '@/mixins'
import axios from 'axios'
export default {
  mixins: [EntityMixin],
  props: {
    invert: {
      type: Boolean,
      default: true,
    },
    entity: null,
    relation: null,
    vertical: {
      type: Boolean,
      default: false,
    },
    extraLoad: null,
    chips: null,
    parentInstance: null,
    parent: null,
    path: null,
    parentPath: null,
    showInfo: null,
    extraData: null,
    isSection: null,
    isActive: null,
  },
  data: () => ({
    dialog: false,
    parties: [],
    groupParties: []
  }),
  methods: {
    setInstance(instance) {
      if(this.parties.filter(p => p.id == instance.id).length == 0) {
        var groupParty = this.mapGroupParty(instance, 4);
        this.$store.commit('SET_INSTANCE_PATH', { path: this.path + '['+ this.$store.state.instance.groupParties.length +']', value: groupParty });
        this.parties.push(instance);
      }
    },
    removeParty(party) {

      this.groupParties = this.$store.state.instance.groupParties;

      if(this.groupParties.find(x => x.partyId == party.id).entityState == 0)
      {
        this.groupParties.find(x => x.partyId == party.id).entityState = 2
      }
      else{
        this.groupParties = this.groupParties.filter(p => p.partyId != party.id)
      }
      this.parties = this.parties.filter(p => p.id != party.id)
      this.$store.commit('SET_INSTANCE_PATH', { path: this.path, value: this.groupParties });


    },
    mapGroupParty(party, entityState) {
      return {
        _Entity: 'GroupEntity',
        entityState: entityState,
        partyId: party.id,
        entity: 'Party'
      };
    },
    onClick() {
      this.$store.commit('SET_MODAL_INSTANCE', { extraData: [], entityState: 4, _Entity: this.entity.name });
      this.dialog = true;
    },
    onCloseDisplay() {
      let entityState = _.get(this.parentInstance, 'entityState');
      if (entityState === 3) {
        this.$store.commit('SET_INSTANCE_PATH', { path: this.$getParentKey(this.parent, this.path), value: null });
      }
      this.$store.commit('SET_INSTANCE_PATH', { path: this.path, value: null });
    },

    getAllGroupParties() {
      this.$store.state.instance.groupParties.forEach(element => this.parties.push(element.party));
    },
  },
  computed: {
    // Error related computeds
    errors() {
      return this.$store.state.errors;
    },
    labelHash() {
      return this.path;
    },
    hasErrors() {
      return Object.keys(this.errors).find(k => k.includes(this.labelHash));
    },
    searchErrors() {
      return (this.hasErrors && 'Select valid') || '';
    },
    // Selector needs to load extraData if posible
    searchLoads() {
      return this.$isExtraDateable(this.entity) ? ['ExtraData'] : [];
    },
    partyEntity () {
      return this.$findEntity('Party')
    },
  },
  async created () {
    this.getAllGroupParties()
  },
}
</script>
